import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/_home": [5],
		"/aa-offer": [6],
		"/app-choice": [7],
		"/assessment-purchase": [8],
		"/cancel-subscription": [9,[2]],
		"/cancel-subscription/assessment-center": [10,[2]],
		"/cancel-subscription/cancel-feedback": [11,[2]],
		"/cancel-subscription/confirmation": [12,[2]],
		"/cancel-subscription/pause": [13,[2]],
		"/cancel-subscription/pause/manage": [14,[2]],
		"/cancel-subscription/pause/success": [15,[2]],
		"/cancel-subscription/save-offer": [16,[2]],
		"/cancel-subscription/success": [17,[2]],
		"/claimed-offer": [18],
		"/debug/experiment-assign": [19],
		"/debug/experiment-assign/personalized-cancel": [20],
		"/desktop-choice": [21],
		"/download-app": [22],
		"/email-preferences": [23],
		"/expired": [24],
		"/forgot-password": [25],
		"/get-started": [26],
		"/inbound-gateway": [27],
		"/inside-pw": [28],
		"/login": [29],
		"/logout": [30],
		"/parent-section": [31,[3]],
		"/parent-section/assessment-center": [32,[3]],
		"/parent-section/membership": [33,[3]],
		"/parent-section/membership/billing": [34,[3]],
		"/parent-section/membership/payment": [35,[3]],
		"/password-reset-success": [37],
		"/password-reset": [36],
		"/premium": [38],
		"/printables": [39],
		"/prospect-register": [40],
		"/purchase-gift": [41],
		"/qr-entry": [42],
		"/reactivation": [43],
		"/redeem": [44],
		"/reset-link-expired": [45],
		"/subscription-consume": [48],
		"/subscription": [46],
		"/subscription/offer/[offer_hash]": [47],
		"/support-chatbot": [49],
		"/terminate": [50],
		"/unsupported-browser": [51],
		"/upgrade": [52]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,

	reroute: (() => {})
};

export { default as root } from '../root.svelte';